module.exports = __webpack_public_path__ + "img/zyjy_08.a58591a3.png";